var indexOf = [].indexOf

module.exports = function(arr, obj){
  if (indexOf) return arr.indexOf(obj);
  for (var i = 0, il = arr.length; i < il; ++i) {
    if (arr[i] === obj) return i;
  }
  return -1
}



//////////////////
// WEBPACK FOOTER
// /var/www/nitrointeractive.dev/releases/20220802215704/web/app/themes/catalyst-2018/node_modules/list.js/src/utils/index-of.js
// module id = 6
// module chunks = 0